import { getQueryClient } from '@/app/query-client';
import { getApiUrl } from './utils';

export function getCsrfToken(baseUrl = getApiUrl()): Promise<string> {
  return getQueryClient().fetchQuery({
    queryKey: ['csrf-token', baseUrl],
    staleTime: 0,
    gcTime: 0,
    networkMode: 'always',
    queryFn: async () => {
      const response = await fetch(`${baseUrl}/auth/csrf/`, {
        credentials: 'include',
        cache: 'no-store',
      });
      if (!response.ok) {
        throw new Error('Could not prepare your request. Please try again.');
      }
      const result = (await response.json()) as { data: { csrf_token: string } };
      return result.data.csrf_token;
    },
  });
}
